import { DatePicker, Select } from 'antd';
import moment from 'moment';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import Button from '../Button';
import SelectCampus from '../SelectCampus';

interface IProps {
  startDate: string;
  setStartDate: (date: string) => void;
  endDate: string;
  setEndDate: (date: string) => void;
  sendType: string;
  setSendType: (type: string) => void;
  sendTimeDiv: string;
  setSendTimeDiv: (type: string) => void;
  onSearch: () => void;
  onSend: () => void;
  memberName: string;
  setMemberName: (name: string) => void;
  campusDeactived: boolean;
}

const SearchBar: FC<IProps> = ({
  startDate,
  setStartDate,
  endDate,
  setEndDate,
  sendType,
  setSendType,
  sendTimeDiv,
  setSendTimeDiv,
  onSearch,
  onSend,
  memberName,
  setMemberName,
  campusDeactived,
}) => {
  const { t } = useTranslation();

  return (
    <>
    <div className="common-search">
      <div className="search-area">
        <ul className="search-bx">
          <li>
            <label>
            {t('class.class.placeholder1')}
            </label>
            <div>
              <SelectCampus />
            </div>
          </li>
          <li>
            <label>
              {t('sms.list.column1')}
            </label>
            <div className="date-picker__area">
              <DatePicker
                value={startDate ? moment(startDate) : undefined}
                onChange={(e) => {
                  if (e === null) setStartDate('');
                  else setStartDate(moment(e).format('YYYYMMDD'));
                }}
              />
            </div>
            ~
            <div className="date-picker__area">
              <DatePicker
                value={endDate ? moment(endDate) : undefined}
                onChange={(e) => {
                  if (e === null) setEndDate('');
                  else setEndDate(moment(e).format('YYYYMMDD'));
                }}
              />
            </div>
          </li>
          <li>
            <label>
              {t('sms.list.column2')}
            </label>
            <div>
              <Select
                value={sendType}
                onChange={(value) => setSendType(value)}
              >
                <Select.Option value="ALL">{t('common.text.all')}</Select.Option>
                <Select.Option value="GE">
                  {t('student.student.option20')}
                </Select.Option>
                <Select.Option value="AD">
                  {t('student.student.option21')}
                </Select.Option>
              </Select>
            </div>
          </li>
          <li>
            <label>
              {t('sms.list.column3')}
            </label>
            <div>
              <Select
                value={sendTimeDiv}
                onChange={(value) => setSendTimeDiv(value)}
              >
                <Select.Option value="ALL">{t('common.text.all')}</Select.Option>
                <Select.Option value="IM">
                  {t('student.student.option22')}
                </Select.Option>
                <Select.Option value="RE">
                  {t('student.student.option23')}
                </Select.Option>
                <Select.Option value="CN">{t('sms.list.option1')}</Select.Option>
              </Select>
            </div>
          </li>
          <li>
            <label>{t('sms.text.1')}</label>
            <input
              type="text"
              className="form-control w-150p"
              placeholder={t('sms.text.1')}
              value={memberName}
              onChange={(e) => setMemberName(e.target.value)}
              onKeyPress={(e) => {
                if (e.key === 'Enter') {
                  onSearch();
                }
              }}
              />
            <div className="comm-btn__area">
              <Button
                className="btn-basic small black"
                onClick={onSearch}
                text={t('common.button.search')}
              />
              <Button
                className="btn-basic pink-line"
                onClick={onSend}
                text={t('student.student.button10')}
                disabled={campusDeactived}
              />
            </div>
          </li>
        </ul>
      </div>
    </div>
    </>
  );
};

export default SearchBar;
